import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import DashboardProveedor from "./dashboardProveedor/dashboardProveedor";
import HistoricoTarifasProveedor from "./historicoTarifasProveedor/historicoTarifasProveedor";
import SectionHeader from "../../components/sectionHeader/sectionHeader";
import Tabs from "../../components/tabs/tabs";
import ValidacionGOIProveedor from "./validacionGOIProveedor/validacionGOIProveedor";
import Precio from "../dashboard/gestionTarifas/pages/precio/precio";

export default function GestionTarifasProveedor({ user }) {
    const isV2 = window.config?.isV2;
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("tarifasPendientes");

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const tabFromUrl = urlParams.get('activeTab');
        if (tabFromUrl) {
            setActiveTab(tabFromUrl);
        }
    }, [location.search]);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
    };

    const tabs = [
        { id: "tarifasPendientes", label: "Mis pendientes" },
        { id: "historicoTarifas", label: "Histórico tarifas" },
        { id: "validacionGOI", label: "Tarifas GOI" },
        {id: "precio", label: "Calculadora de precios" },
    ];

    isV2 && tabs.push({id: "precioV2", label: "Calculadora de precios_V2" });

    return (
        <section className="dashboard-usuarios">
            <SectionHeader
                title="Panel de Administrador - Gestión de tarifas"
                subtitle="Aquí puedes gestionar las solicitudes pendientes, y ver el histórico de tarifas"
            />

            <Tabs
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={handleTabChange}
            />

            <div className="dashboard-usuarios__content">
                {activeTab === "historicoTarifas" && (
                    <HistoricoTarifasProveedor user={user} />
                )}

                {activeTab === "tarifasPendientes" && (
                    <DashboardProveedor user={user} />
                )}
                {activeTab === "validacionGOI" && (
                    <ValidacionGOIProveedor user={user} />
                )}
                {activeTab === "precio" && <Precio user={user} />}
                {(activeTab === "precioV2" && isV2) && <Precio user={user} isV2={true} />}
            </div>
        </section>
    );
}
